<div *ngIf="valider == false" id="recallModal">
  <div class="modal-content">
    <div class="modalContainer">
      <form action="">
        <div class="cardModalTitle">
          <h4>Être rappelé</h4>
          <span class="close" (click)="closeModals()">
            <img src="assets/img/close-white.svg" alt="" />
          </span>
        </div>
        <div class="cardModalContent">
          <p>
            Avant d’être rappelé par l’un de nos conseillés, confirmez-nous
            votre numéro de téléphone :
          </p>
          <input
            #inputTelephone="ngModel"
            type="tel"
            class="modalCallInput"
            name="inputTelephone"
            id=""
            minlength="10"
            maxlength="10"
            [required]="true"
            [(ngModel)]="data.telephone"
            pattern="^(33|0)([1-7]|9)\d{8}$"
          />
          <div
            *ngIf="inputTelephone.invalid && inputTelephone.dirty"
            class="alert alert-danger"
          >
            Veuillez renseigner un numero de téléphone valide.
          </div>
          <div
            *ngIf="telephoneInexistant(data.telephone)"
            class="alert alert-danger"
          >
            Veuillez renseigner un numero de téléphone valide.
          </div>
          <!-- <div *ngIf="regexPhoneNumber(data.telephone) == false" class="alert alert-danger">
                        Veuillez renseigner un numero de téléphone valide, numero français invalide.
                    </div> -->

          <p class="autreDemandeDevis">
            Vous pouvez aussi souscrire par téléphone au
            <span>{{ number_phone }}</span>
            (prix d'un appel normal) <br />
            Du lundi au vendredi de 9h à 19h.
          </p>
          <input
            [disabled]="
              (inputTelephone.invalid && inputTelephone.dirty) ||
              telephoneInexistant(data.telephone)
            "
            type="button"
            (click)="validerRappel()"
            value="Valider"
            class="modalButton"
          />
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="valider == true" id="recallCheckModal">
  <div class="modal-content">
    <span class="close closeModal2" (click)="closeModals()">
      <img src="assets/img/close.svg" alt="" />
    </span>
    <div class="modalContainer">
      <img src="assets/img/callCheck.svg" id="avatar" alt="" />

      <form action="">
        <p>
          Votre demande de rappel a bien été enregistré.
          <br class="breakLine" />
          Un conseiller va vous rappeler dans les plus brefs délais.
        </p>
        <div class="recapOffre">
          <div class="recapImage">
            <img
              class="scaleImg"
              *ngIf="
                data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE_ECO' ||
                data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE'
              "
              src="assets/img/100FamilleSante.svg"
              style="width: 90%"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE'"
              src="assets/img/Essentiel_Plus_Sante.svg"
              style="width: 90%"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE_ECO'"
              src="assets/img/Essentiel_Plus_Sante_Eco.svg"
              style="width: 90%"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="
                data.tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE_ECO' ||
                data.tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE'
              "
              src="assets/img/100FamilleSante.svg"
              style="width: 90%"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'RELAXEO2'"
              src="assets/img/Relaxeo.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'VITAMIN3'"
              src="assets/img/apivia.png"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'PARTICULIER'"
              src="assets/img/SLPart.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'SWLF_RETRAITES'"
              src="assets/img/SLSenior"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="
                data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO' ||
                data.tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO'
              "
              src="assets/img/aesio_imm_senior_eco.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="
                data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR' ||
                data.tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR'
              "
              src="assets/img/aesio_imm_senior.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'PROGR_SANTE_FAMILLE'"
              src="assets/img/prog_sante_famille.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'PROGR_SANTE_SENIOR'"
              src="assets/img/prog_sante_senior.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'CEGEMAV'"
              src="assets/img/vitaneor.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'CEGE_EQUILIBRE'"
              src="assets/img/cegema-flexibilite.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="
                data.tarif.produitTarif ==
                  'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
                data.tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE'
              "
              src="assets/img/cegema-flexibilite.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'KEREIS_SERENITE'"
              src="assets/img/cegema-serenite-sante.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'AC_PRIVILEGE'"
              src="assets/img/OptimumSante.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'CEGEMAEss'"
              src="assets/img/essentiel2.svg"
              alt=""
            />
          </div>
          <div class="recapPrix">
            <div class="mensuel">
              <span class="prix">{{
                (ate(data.tarif.montant!) | number: '1.1-2')?.split('.')?.[0] ??
                  '0'
              }}</span>
              ,{{
                (ate(data.tarif.montant!) | number: '1.1-2')?.split('.')?.[1] ??
                  '00'
              }}€/mois
            </div>
            <div class="annuel">
              Soit
              {{ ate(data.tarif.montant!) * 12 | number: '1.1-2' : 'fr' }}€/an
              tout inclus
            </div>
          </div>
        </div>
        <div class="dossierRef">
          Référence du dossier : <span>XB232133</span>
        </div>
        <p class="autreDemandeDevis">
          Vous pouvez aussi souscrire par téléphone au
          <span>{{ number_phone }}</span>
          (prix d'un appel normal) <br />
          Du lundi au vendredi de 9h à 19h.
        </p>
        <input
          type="button"
          value="Retour à la liste des offres"
          class="modalButton"
          [mat-dialog-close]="data.telephone"
          cdkFocusInitial
        />
      </form>
    </div>
  </div>
</div>
